import React, { useState, useEffect } from 'react';
import momentTimezone from 'moment-timezone';

import { TextMedium } from 'lib/common/text';

export const Clock = ({ format = 'HH:mm z', timeZone = 'Europe/London', intervalMillis = 30000 }) => {
    function getTime() {
        const time = new Date().getTime();
        const localizedTime = momentTimezone(time).tz(timeZone);
        return localizedTime.format(format);
    }
    const [timeFormatted, setTimeFormatted] = useState(getTime());

    useEffect(() => {
        const tickTimer = setInterval(() => {
            setTimeFormatted(getTime());
        }, intervalMillis);

        return () => {
            clearInterval(tickTimer);
        };
    }, [intervalMillis]);

    return (
        <TextMedium color="white" bold>
            {timeFormatted}
        </TextMedium>
    );
};
